import { FormikHelpers } from "formik";
import { useCreatePhonecentersMaintenance } from "./api/createPhonecentersMaintenance";
import PhonecentersMaintenanceForm from "./PhonecentersMaintenanceForm";


const CreatePhonecentersMaintenance = ({handleCloseModal}: CreatePhonecentersMaintenanceProps)  => {
  const createPhonecentersMaintenanceMutation = useCreatePhonecentersMaintenance({data: {}});

  const initialValues: IPostNewPhonecentersMaintenance = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewPhonecentersMaintenance, { setSubmitting }: FormikHelpers<IPostNewPhonecentersMaintenance>): Promise<void> => {
    try {
      await createPhonecentersMaintenanceMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PhonecentersMaintenanceForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreatePhonecentersMaintenanceProps {
  handleCloseModal: () => void;
}

export default CreatePhonecentersMaintenance;